import { useEffect, useState } from 'react'

import styles from './CommonSettings.module.css'
import { AppDispatch } from '../../../redux/store'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import {
  fetchAddSettings,
  fetchSettings,
} from '../../../redux/reducers/settings'
import {
  fetchAddCities,
  fetchCities,
  fetchDeleteCities,
} from '../../../redux/reducers/cities'
import DeleteButton from '../../../components/buttons/actions-button/DeleteButton'
import {
  fetchAddDictionaryExpenses,
  fetchDictionaryDeleteExpenses,
  fetchDictionaryExpenses,
} from '../../../redux/reducers/dictionary'
import { dictionarySelector } from '../../../redux/selectors/dictionary-expenses-selector'
import { settingsSelector } from '../../../redux/selectors/settings-selector'
import EditButton from '../../../components/buttons/actions-button/EditButton'
import {
  fetchAddCountries,
  fetchCountries,
  fetchDeleteCountries,
} from '../../../redux/reducers/countries'
import { countriesSelector } from '../../../redux/selectors/countries-selector'
import { citiesSelector } from '../../../redux/selectors/cities-selector'
import Spinner from '../../../components/spinner/Spinner'
import DeleteModal from '../../../components/modal/DeleteModal'
import { onlyNumberRegularCheck } from '../../../utils/onlyNumberRegularCheck'

function CommonSettings() {
  const dispatch = useDispatch<AppDispatch>()
  const [addExpensesVisible, setAddExpensesVisible] = useState(false)
  const [addCountriesVisible, setAddCountriesVisible] = useState(false)
  const [addCitiesVisible, setAddCitiesVisible] = useState(false)
  const [selectedCountry, setSelectedCountry] = useState<string | null>(null)

  const {
    dictionary,
    isPendingGetDictionary,
    isPendingAddDictionary,
    isPendingDeleteDictionary,
  } = useSelector(dictionarySelector)
  const { settings, isPending } = useSelector(settingsSelector)
  const {
    countries,
    isPendingGetCountry,
    isPendingAddCountry,
    isPendingDeleteCountry,
  } = useSelector(countriesSelector)

  const {
    cities,
    isPendingGetCities,
    isPendingAddCities,
    isPendingDeleteCities,
  } = useSelector(citiesSelector)

  useEffect(() => {
    dispatch(fetchSettings())
    dispatch(fetchCountries())
    dispatch(fetchCities())
    dispatch(fetchDictionaryExpenses())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Устанавливаем первую страну как выбранную при загрузке
  useEffect(() => {
    if (countries && countries.length > 0) {
      setSelectedCountry((prev) => {
        if (!prev) {
          return countries[0].iso
        }
        return prev
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countries])

  const [settingsValue, setSettingsValue] = useState(
    settings?.find((s) => s.slug === 'travelAllowances')?.value || ''
  )
  const [travelPurposeValue, setTravelPurposeValue] = useState(
    settings?.find((s) => s.slug === 'travelPurpose')?.value || ''
  )
  const [jobTitleValue, setJobTitleValue] = useState(
    settings?.find((s) => s.slug === 'jobTitle')?.value || ''
  )

  const [originalTravelAllowances, setOriginalTravelAllowances] = useState(
    settings?.find((s) => s.slug === 'travelAllowances')?.value || ''
  )
  const [originalTravelPurpose, setOriginalTravelPurpose] = useState(
    settings?.find((s) => s.slug === 'travelPurpose')?.value || ''
  )
  const [originalJobTitle, setOriginalJobTitle] = useState(
    settings?.find((s) => s.slug === 'jobTitle')?.value || ''
  )

  useEffect(() => {
    const travelAllowancesValue =
      settings?.find((s) => s.slug === 'travelAllowances')?.value || ''
    const travelPurposeValueSetting =
      settings?.find((s) => s.slug === 'travelPurpose')?.value || ''
    const jobTitleValueSetting =
      settings?.find((s) => s.slug === 'jobTitle')?.value || ''

    setSettingsValue(travelAllowancesValue)
    setTravelPurposeValue(travelPurposeValueSetting)
    setJobTitleValue(jobTitleValueSetting)

    setOriginalTravelAllowances(travelAllowancesValue)
    setOriginalTravelPurpose(travelPurposeValueSetting)
    setOriginalJobTitle(jobTitleValueSetting)
  }, [settings])

  const hasTravelAllowancesChanges =
    String(settingsValue) !== String(originalTravelAllowances)
  const hasTravelPurposeChanges =
    String(travelPurposeValue) !== String(originalTravelPurpose)
  const hasJobTitleChanges = String(jobTitleValue) !== String(originalJobTitle)
  function ChangeItem({ setIsVisibleModal, children, title }: any) {
    const handleClose = () => {
      setIsVisibleModal(false)
    }

    return (
      <div style={{ display: 'block' }} className={styles.win}>
        <div className={styles.winContainer}>
          <div className={styles.winContent}>
            <div onClick={handleClose} className={styles.close}>
              ×
            </div>
            <div className={styles.winContentFulltext}>
              <h3
                style={{ textAlign: 'center' }}
                className={classNames(`mb-4 ${styles.h3}}`)}
              >
                {title}
              </h3>
              {children}
            </div>
          </div>
        </div>
      </div>
    )
  }

  const [currentExpenses, setCurrentExpenses] = useState<any>(null)
  const [deleteExpenses, setDeleteExpenses] = useState<boolean>(false)
  const handleDeleteExpenses = () => {
    dispatch(fetchDictionaryDeleteExpenses(currentExpenses?.item?.slug)).then(
      (res) => {
        //@ts-ignore
        if (!res.error) {
          setDeleteExpenses(false)
          setCurrentExpenses(null)
        }
      }
    )
  }
  const ItemExpenses = (item: any) => {
    return (
      <div className="row mb-1 align-items-center">
        <div className="col pr-1">
          <input value={item?.item?.name} type="text" readOnly />
        </div>
        <div className="col-auto pl-0 pr-0">
          <EditButton
            onClick={() => {
              setAddExpensesVisible(true)
              setCurrentExpenses(item)
            }}
          />
          <DeleteButton
            onClick={() => {
              setDeleteExpenses(true)
              setCurrentExpenses(item)
            }}
          />
        </div>
      </div>
    )
  }

  const [currentCountry, setCurrentCountry] = useState<any>(null)
  const [deleteCountries, setDeleteCountries] = useState<boolean>(false)

  const handleDeleteCountries = () => {
    dispatch(fetchDeleteCountries(currentCountry?.item?.iso)).then((res) => {
      //@ts-ignore
      if (!res.error) {
        setDeleteCountries(false)
        setCurrentCountry(null)
      }
    })
  }
  const ItemCountry = (item: any) => {
    return (
      <>
        <div className="row mb-1 align-items-center">
          <div className="col pr-1">
            <input value={item?.item?.name} type="text" readOnly />
          </div>

          <div className="col-auto pl-0 pr-0">
            <EditButton
              onClick={() => {
                setAddCountriesVisible(true)
                setCurrentCountry(item)
              }}
            />
            <DeleteButton
              onClick={() => {
                setDeleteCountries(true)
                setCurrentCountry(item)
              }}
            />
          </div>
        </div>
      </>
    )
  }

  const AddItemCountries = (item: any) => {
    const [name, setName] = useState(currentCountry?.item?.name || '')
    //@ts-ignore
    const [iso, setIso] = useState(currentCountry?.item?.iso || '')

    const handleAddCountry = () => {
      if (currentCountry) {
        dispatch(
          fetchAddCountries({ name, iso, prevValue: currentCountry?.item?.iso })
        ).then((res) => {
          //@ts-ignore
          if (!res.error) {
            setAddCountriesVisible(false)
          }
        })
      } else {
        dispatch(fetchAddCountries({ name, iso })).then((res) => {
          //@ts-ignore
          if (!res.error) {
            setAddCountriesVisible(false)
          }
        })
      }
    }

    useEffect(() => {
      return () => {
        setCurrentCountry(null)
      }
    }, [])

    return (
      <>
        <div className="row mb-1 align-items-center">
          <div className="col pr-1">
            Страна*
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              type="text"
              className="mb-4"
            />
            Обозначение(BY, RU, KZ...)*
            <input
              value={iso}
              onChange={(e) => setIso(e.target.value)}
              type="text"
            />
          </div>
        </div>
        <div className="d-flex flex-wrap justify-content-between mt-4 mb-2">
          <button
            className={classNames(styles.btn, styles.btnSmall)}
            onClick={handleAddCountry}
            disabled={!name || !iso}
          >
            Сохранить
          </button>
          <div
            className={classNames(
              styles.btn,
              styles.btnSmall2,
              styles.btnBlueOutline,
              styles.cancelBtn
            )}
            onClick={() => setAddCountriesVisible(false)}
          >
            Отмена
          </div>
        </div>
      </>
    )
  }

  const handleDeleteCities = () => {
    dispatch(
      fetchDeleteCities({
        country: currentCities.item.country.iso,
        id: currentCities.item.id,
      })
    ).then((res) => {
      //@ts-ignore
      if (!res.error) {
        setDeleteCities(false)

        setCurrentCities(null)
      }
    })
  }
  const [currentCities, setCurrentCities] = useState<any>(null)
  const [deleteCities, setDeleteCities] = useState<boolean>(false)

  const ItemCities = (item: any) => {
    return (
      <div className="row mb-1 align-items-center">
        <div className="col pr-1">
          <input value={item?.item?.name} type="text" readOnly />
        </div>
        <div className="col-auto pl-0 pr-0">
          <EditButton
            onClick={() => {
              setAddCitiesVisible(true)
              setCurrentCities(item)
            }}
          />
          <DeleteButton
            onClick={() => {
              setDeleteCities(true)
              setCurrentCities(item)
            }}
          />
        </div>
      </div>
    )
  }

  const AddItemCities = (item: any) => {
    //@ts-ignore
    const [name, setName] = useState(currentCities?.item?.name || '')
    //@ts-ignore
    const [country, setCountry] = useState(
      currentCities?.item?.country?.iso || selectedCountry || ''
    )

    useEffect(() => {
      if (currentCities) {
        setName(currentCities.item.name || '')
        setCountry(currentCities.item.country?.iso || '')
      } else {
        setName('')
        setCountry(selectedCountry || '')
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentCities])

    useEffect(() => {
      return () => {
        setCurrentCities(null)
      }
    }, [])

    const handleAddCity = () => {
      if (currentCities) {
        dispatch(
          fetchAddCities({ name, country, prevValue: currentCities?.item?.id })
        ).then((res) => {
          //@ts-ignore
          if (!res.error) {
            setAddCitiesVisible(false)
            setCurrentCities(null)
          }
        })
      } else {
        dispatch(fetchAddCities({ name, country })).then((res) => {
          //@ts-ignore
          if (!res.error) {
            setAddCitiesVisible(false)
            setCurrentCities(null)
          }
        })
      }
    }

    return (
      <>
        <div className="row mb-1 align-items-center">
          <div className="col pr-1">
            Город*
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              type="text"
              className="mb-4"
            />
            Страна*
            <select
              value={country}
              onChange={(e) => {
                setCountry(e.target.value)
              }}
            >
              <option value="" key={undefined}>
                — Выберите —
              </option>
              {countries?.map((item) => (
                <option key={item.iso} value={item.iso}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="d-flex flex-wrap justify-content-between mt-4 mb-2">
          <button
            className={classNames(styles.btn, styles.btnSmall)}
            onClick={handleAddCity}
            disabled={!name || !country}
          >
            Сохранить
          </button>
          <div
            className={classNames(
              styles.btn,
              styles.btnSmall2,
              styles.btnBlueOutline,
              styles.cancelBtn
            )}
            onClick={() => {
              setAddCitiesVisible(false)
              setCurrentCities(null)
            }}
          >
            Отмена
          </div>
        </div>
      </>
    )
  }

  const AddItemExpenses = (item: any) => {
    const [name, setName] = useState(currentExpenses?.item?.name || '')
    const [slug, setSlug] = useState(currentExpenses?.item?.slug || '')

    const handleAddExpenses = () => {
      if (currentExpenses) {
        dispatch(
          fetchAddDictionaryExpenses({
            name,
            slug,
            prevValue: currentExpenses?.item?.slug,
          })
        ).then((res) => {
          //@ts-ignore
          if (!res.error) {
            setAddExpensesVisible(false)
            setCurrentExpenses(null)
          }
        })
      } else {
        dispatch(fetchAddDictionaryExpenses({ name, slug })).then((res) => {
          //@ts-ignore
          if (!res.error) {
            setAddExpensesVisible(false)
            setCurrentExpenses(null)
          }
        })
      }
    }
    return (
      <>
        <div className="row mb-1 align-items-center">
          <div className="col pr-1 pt-4">
            Наименование*
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              type="text"
              className="mb-4"
            />
            Обозначение(англ)*
            <input
              value={slug}
              onChange={(e) => setSlug(e.target.value)}
              type="text"
            />
          </div>
        </div>

        <div className="d-flex flex-wrap justify-content-between mt-4 mb-2">
          <button
            className={classNames(styles.btn, styles.btnSmall)}
            onClick={handleAddExpenses}
            disabled={!name || !slug}
          >
            Сохранить
          </button>
          <div
            className={classNames(
              styles.btn,
              styles.btnSmall2,
              styles.btnBlueOutline,
              styles.cancelBtn
            )}
            onClick={() => {
              setCurrentExpenses(null)
              setAddExpensesVisible(false)
            }}
          >
            Отмена
          </div>
        </div>
      </>
    )
  }

  if (
    isPendingGetCities ||
    isPendingAddCities ||
    isPendingDeleteCities ||
    isPendingGetCountry ||
    isPendingAddCountry ||
    isPendingDeleteCountry ||
    isPendingGetDictionary ||
    isPendingAddDictionary ||
    isPendingDeleteDictionary ||
    isPending
  ) {
    return <Spinner />
  }

  const handleSettingsChange = (e: any, slug: string = 'travelAllowances') => {
    const value =
      slug === 'travelAllowances'
        ? e.target.value.replace(',', '.')
        : e.target.value
    if (slug === 'travelAllowances') {
      setSettingsValue(value)
    } else if (slug === 'travelPurpose') {
      setTravelPurposeValue(value)
    } else if (slug === 'jobTitle') {
      setJobTitleValue(value)
    }
  }

  const handleSaveSettings = (slug: string = 'travelAllowances') => {
    let value = ''
    if (slug === 'travelAllowances') {
      value = String(settingsValue)
    } else if (slug === 'travelPurpose') {
      value = String(travelPurposeValue)
    } else if (slug === 'jobTitle') {
      value = String(jobTitleValue)
    }

    dispatch(fetchAddSettings({ value, slug })).then((result: any) => {
      // Перезагружаем настройки после успешного сохранения
      if (!result.error) {
        dispatch(fetchSettings())
      }
    })
  }

  return (
    <div>
      <div className={classNames(styles.blockWhite)}>
        <div className="row">
          <div className="col-12 col-sm-12 col-md-6 mt-1 mb-1">
            <div className={classNames(styles.bgGray)}>
              <div className="mb-2">
                <b>Страны</b>
                {countries?.map((item) => (
                  <ItemCountry key={item.iso} item={item} />
                ))}

                <div
                  className={classNames(
                    styles.btn,
                    styles.btnSmall2,
                    styles.btnBlue
                  )}
                  onClick={() => setAddCountriesVisible(true)}
                >
                  + Добавить
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-6 mt-1 mb-1">
            <div className={classNames(styles.bgGray)}>
              <div className="mb-2">
                <b>Города</b>
                {countries && countries.length > 0 && (
                  <div
                    className={classNames(
                      styles.tabs,
                      styles.radioTabs,
                      'd-flex flex-wrap align-items-end justify-content-start small-2 mb-2'
                    )}
                  >
                    {[...countries]
                      .sort((a, b) => a.name.localeCompare(b.name, 'ru'))
                      .map((country) => (
                        <div className="mt-1 mb-1" key={country.iso}>
                          <input
                            type="radio"
                            name="countries_radio"
                            id={`tab_country_${country.iso}`}
                            value={country.iso}
                            checked={selectedCountry === country.iso}
                            onChange={() => setSelectedCountry(country.iso)}
                          />
                          <label htmlFor={`tab_country_${country.iso}`}>
                            {country.name}
                          </label>
                        </div>
                      ))}
                  </div>
                )}

                {selectedCountry && (
                  <div
                    className="tab-content"
                    data-content={`tab_country_${selectedCountry}`}
                    style={{ display: 'block' }}
                  >
                    {cities
                      ?.filter((city) => city.country?.iso === selectedCountry)
                      .map((item) => <ItemCities key={item.id} item={item} />)}
                    <div
                      className={classNames(
                        styles.btn,
                        styles.btnSmall2,
                        styles.btnBlue
                      )}
                      onClick={() => {
                        setCurrentCities(null)
                        setAddCitiesVisible(true)
                      }}
                    >
                      + Добавить
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-12 col-md-6 mt-1 mb-1">
            <div className={classNames(styles.bgGray)}>
              <div className="mb-2">
                <b>Командировочные</b>, EUR:
              </div>
              <div className="row align-items-center">
                <div className="col pr-1">
                  <input
                    value={settingsValue}
                    onChange={(e) => {
                      if (onlyNumberRegularCheck(e)) {
                        handleSettingsChange(e, 'travelAllowances')
                      }
                    }}
                    className="w-100"
                    type="text"
                  />
                </div>
                <div className="col-auto pl-0">
                  <button
                    className={classNames(
                      styles.btn,
                      styles.btnSmall2,
                      styles.btnBlue,
                      styles.btnIcon
                    )}
                    onClick={() => handleSaveSettings('travelAllowances')}
                    disabled={!hasTravelAllowancesChanges}
                  >
                    <i className={classNames(styles.icon, styles.iconSave)}></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-12 col-md-6 mt-1 mb-1">
            <div className={classNames(styles.bgGray)}>
              <div className="mb-2">
                <b>Цель командировки</b>:
              </div>
              <div className="row align-items-center">
                <div className="col pr-1">
                  <input
                    value={travelPurposeValue || ''}
                    onChange={(e) => {
                      handleSettingsChange(e, 'travelPurpose')
                    }}
                    className="w-100"
                    type="text"
                  />
                </div>
                <div className="col-auto pl-0">
                  <button
                    className={classNames(
                      styles.btn,
                      styles.btnSmall2,
                      styles.btnBlue,
                      styles.btnIcon
                    )}
                    onClick={() => handleSaveSettings('travelPurpose')}
                    disabled={!hasTravelPurposeChanges}
                  >
                    <i className={classNames(styles.icon, styles.iconSave)}></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-12 col-md-6 mt-1 mb-1">
            <div className={classNames(styles.bgGray)}>
              <div className="mb-2">
                <b>Должность</b>:
              </div>
              <div className="row align-items-center">
                <div className="col pr-1">
                  <input
                    value={jobTitleValue || ''}
                    onChange={(e) => {
                      handleSettingsChange(e, 'jobTitle')
                    }}
                    className="w-100"
                    type="text"
                  />
                </div>
                <div className="col-auto pl-0">
                  <button
                    className={classNames(
                      styles.btn,
                      styles.btnSmall2,
                      styles.btnBlue,
                      styles.btnIcon
                    )}
                    onClick={() => handleSaveSettings('jobTitle')}
                    disabled={!hasJobTitleChanges}
                  >
                    <i className={classNames(styles.icon, styles.iconSave)}></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-12 col-md-6 mt-1 mb-1">
            <div className={classNames(styles.bgGray)}>
              <div className="mb-2">
                <b>Список расходов</b>
              </div>

              {dictionary?.map((item) => (
                <ItemExpenses key={item.slug} item={item} />
              ))}

              <div
                className={classNames(
                  styles.btn,
                  styles.btnSmall2,
                  styles.btnBlue
                )}
                onClick={() => setAddExpensesVisible(true)}
              >
                + Добавить
              </div>
            </div>
          </div>
        </div>
      </div>
      {addCitiesVisible && (
        <ChangeItem
          setIsVisibleModal={(visible: boolean) => {
            setAddCitiesVisible(visible)
            if (!visible) {
              setCurrentCities(null)
            }
          }}
          title={'Город'}
        >
          <AddItemCities />
        </ChangeItem>
      )}
      {addCountriesVisible && (
        <ChangeItem setIsVisibleModal={setAddCountriesVisible} title={'Страна'}>
          <AddItemCountries />
        </ChangeItem>
      )}

      {addExpensesVisible && (
        <ChangeItem
          setIsVisibleModal={setAddExpensesVisible}
          title={'Вид расхода'}
        >
          <AddItemExpenses />
        </ChangeItem>
      )}

      {deleteCities && (
        <DeleteModal
          title="Город"
          onConfirm={handleDeleteCities}
          onCancel={() => {
            setDeleteCities(false)
            setCurrentCities(null)
          }}
        />
      )}

      {deleteCountries && (
        <DeleteModal
          title="Страна"
          onConfirm={handleDeleteCountries}
          onCancel={() => {
            setCurrentCountry(null)
            setDeleteCountries(false)
          }}
        />
      )}

      {deleteExpenses && (
        <DeleteModal
          title="Вид расхода"
          onConfirm={handleDeleteExpenses}
          onCancel={() => {
            setCurrentExpenses(null)
            setDeleteExpenses(false)
          }}
        />
      )}
    </div>
  )
}

export default CommonSettings
